import React from 'react'
import { Typography, makeStyles, Button, Grid, Container} from '@material-ui/core'
import {ArrowRightAlt} from '@material-ui/icons'
import {Link} from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    
    contentWrapper:{
        // backgroundColor: 'red',
        background: `linear-gradient(180deg, ${theme.palette.secondary.dark}, #ffffff )`,
        padding: '70px 0',
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems:'center',
        [theme.breakpoints.down('sm')]:{
            
            marginTop:'30px'
        },
    },
    sectionHeading: {
        fontSize: '72px',
        fontWeight: 600,
        letterSpacing: 0.1,
        margin: '20px 0px',
        lineHeight: '60px',
        [theme.breakpoints.down('md')]:{
            fontSize: '60px',
        },
        [theme.breakpoints.down('sm')]:{
            fontSize: '48px',
            lineHeight: '40px',
            marginTop:'30px'
        }
    },
    note1:{
        margin: '15px 10px 10px 20px',
        fontWeight:600
    },
    note2:{
        color: theme.palette.secondary.dark,
        marginLeft: '20px',
        fontSize: '24px',
        fontWeight:'500'
    },
    exploreBtn:{
        color: 'black',
        marginLeft: '20px',
        boxShadow: 'none',
        borderRadius: 2,
        padding: '10px 75px',
        margin: '20px 0',
        '&:hover':{
            color: theme.palette.secondary.light
        }
    },
    pubImg:{
        width: '80%',
        margin: '0 auto'
    },
    pubName: {
        margin: '15px 0'
    },
    pubInfo:{
        fontSize: '15px'
    }
}))

function AssociatedPublications() {
    const classes = useStyles()
    return (
        <Container maxWidth="xl">
            <div className={classes.contentWrapper}>
                <Container>
                    <h2 className={classes.sectionHeading}>Associated Publications</h2>
                    <p style={{marginBottom:'40px'}}>Competently iterate team building potentialities and team driven alignments. Appropriately enhance cost effective web-readiness for sticky collaboration and idea-sharing. Collaboratively disseminate cross functional collaboration and idea-sharing without</p>
                    <Grid container spacing={5}>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <div>
                                <img src="./assets/images/pub-1.png" className={classes.pubImg} alt="Pub Name"/>
                                <Typography variant="h6" className={classes.pubName}>Coming Clean</Typography>
                                <p className={classes.pubInfo}>Competently iterate team building potentialities and team driven alignments.</p>
                                
                                <Link to="/shop" style={{textDecoration:'none'}}>
                                    <Button color="secondary" endIcon={<ArrowRightAlt />}>Buy Now</Button>
                                </Link>
                            </div>

                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <div>
                                <img src="./assets/images/pub-2.png" className={classes.pubImg} alt="Pub Name"/>
                                <Typography variant="h6" className={classes.pubName}>Migrant Journey To Marine</Typography>
                                <p className={classes.pubInfo}>Competently iterate team building potentialities and team driven alignments.</p>
                                <Link to="/shop" style={{textDecoration:'none'}}>
                                    <Button color="secondary" endIcon={<ArrowRightAlt />}>Buy Now</Button>
                                </Link>
                            </div>

                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <div>
                                <Link to="/paper-jumpsuit">
                                    <img src="./assets/images/pub-3.png" className={classes.pubImg} alt="Pub Name"/>
                                </Link>
                                <Typography variant="h6" className={classes.pubName}>Paper Jump Suit</Typography>
                                <p className={classes.pubInfo}>Competently iterate team building potentialities and team driven alignments.</p>
                                <Link to="/shop" style={{textDecoration:'none'}}>
                                    <Button color="secondary" endIcon={<ArrowRightAlt />}>Buy Now</Button>
                                </Link>
                            </div>

                        </Grid>
                    </Grid>               
                </Container>
            </div>
        </Container>
    )
}

export default AssociatedPublications
